import React from 'react'
import PropTypes from 'prop-types'
import capitalize from 'lodash/capitalize'

import { useFormContext } from 'react-hook-form'
import { Box, Typography } from '@mui/material'

import { HHFormPriceField } from 'components/form-fields/v5'
import { FIELD_WIDTH } from 'components/work-order/disposal-ticket-dialog/disposal-fee/fields/settings'

import T from 'T'

const OverageFeeField = ({ index }) => {
  const { control } = useFormContext()

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography>{`${capitalize(T.OVERAGE_FEE)}:`}</Typography>
      <HHFormPriceField sx={{ width: FIELD_WIDTH }} size="small" control={control} name={`materials.${index}.overageFee`} />
    </Box>
  )
}

OverageFeeField.propTypes = {
  index: PropTypes.number,
}

export default OverageFeeField
